import Image from 'next/image'
import Link from 'next/link'
import { ComponentPropsWithoutRef } from 'react'
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogPaper
} from '@/modules/components/ui/dialog'
import { programLink } from '~shared/utils/program-link'
import { Program } from '~shared/api/categories/types'

type Props = {
  programs: Program[]
} & ComponentPropsWithoutRef<typeof Dialog>

export const JournalRelatedCoursesDialog = ({ programs, open, onOpenChange, ...rest }: Props) => {
  return (
    <Dialog {...rest} open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogClose />
        <DialogPaper className='box-border w-full md:w-[500px]'>
          <p className='text-[24px] font-medium leading-[1.2] mb-[24px]'>
            Курсы по теме
          </p>

          <div className='flex flex-col gap-[16px]'>
            {programs.slice(0, 3).map((program, idx) => (
              <div key={program.slug ?? idx} className='flex gap-[14px] items-start'>
                <div className='relative flex-shrink-0 w-10 h-10 rounded-[8px] overflow-hidden'>
                  <Image
                    src={program.image?.url || `/assets/imgs/groups/${idx + 1}.png`}
                    fill
                    alt=''
                    quality={50}
                    sizes='40px'
                    className='object-cover'
                  />
                </div>
                <div className='flex flex-col gap-[8px]'>
                  <span className='text-sm leading-snug'>{program.name}</span>
                  <Link
                    href={programLink(program)}
                    className='text-sm underline underline-offset-2 hover:opacity-70'>
                    Узнать больше
                  </Link>
                </div>
              </div>
            ))}
          </div>

          <p className='text-[13px] text-[#8B8B8B] font-medium tracking-[0.4px] mt-[24px]'>
            Спешите записаться на обучение, количество мест ограничено
          </p>
        </DialogPaper>
      </DialogContent>
    </Dialog>
  )
}